var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{staticClass:"pa-0",attrs:{"dense":""}},[_c('v-list-item-icon',[_c('v-icon',[_vm._v("mdi-account-cash")])],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("10 USD to enter")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }